import React, {Fragment, useEffect} from 'react';
import {Flex, Separator, Icon, Popup, Toggle, FormField} from 'components';
import {over, useField, useNamedSelector, openPopup, useFormikContext} from 'helpers';
import {signIn} from 'store/google-calendar';
import {forbid} from 'store/session';

export function GoogleCalendar(props) {
  const { values } = useFormikContext();
  const [ { value }, { touched }, { setValue, setTouched } ] = useField(props);

  const { user, defaultCalendar } = useNamedSelector('googleCalendar.settings');
  const { premium } = useNamedSelector('session.subscription');
  const getRepetition = useNamedSelector('activities.repetition');

  const calendar = useNamedSelector('googleCalendar.calendarById', { id: value || defaultCalendar }) || { primary: true };
  const calendars = useNamedSelector('googleCalendar.writableCalendars');

  useEffect(() => {
    //set default value (for new activities) only when repetition is valid
    if (!values.id && !touched && defaultCalendar) {
      const isValid = getRepetition(values.repetition) != 'Someday';
      setValue(isValid ? defaultCalendar : undefined);
    }
  }, [ values.id, values.repetition ]);

  const setValueManually = over(setValue, () => setTouched(true));

  return (
    <Fragment>
      <Separator heading="Google Calendar Sync" />
      <FormField onClick={user ? undefined : premium ? signIn : forbid} value>
        <FormField.Label>
          {calendars.length > 0 ? (calendar.primary ? 'Primary Calendar' : calendar.summary) : 'Sign in'}
        </FormField.Label>
        <Flex>
          { user &&
            <Toggle value={Boolean(value)} setValue={on => setValueManually(on ? (defaultCalendar || 'primary') : null)} />
          }
          { user && calendars.length > 1 &&
            <Icon className="secondary" name="menu" onClick={openPopup(CalendarSelector, {value, setValue})} />
          }
        </Flex>
      </FormField>
    </Fragment>
  );
}

function CalendarSelector({ value, setValue }) {
  const calendars = useNamedSelector('googleCalendar.writableCalendars');
  return (
    <Popup.Menu>
      <Popup.Menu.SubHeading>Google Calendar</Popup.Menu.SubHeading>
      { calendars.map(calendar =>
        <Popup.Menu.Item key={calendar.id} onClick={() => setValue(calendar.id)} pressed={value == calendar.id}>
          { calendar.primary ? 'Primary' : calendar.summary }
        </Popup.Menu.Item>
      ) }
    </Popup.Menu>
  );
}
